import { useEffect } from 'react';

export const useSyncSelectedBranch = ({
    selectedInfo,
    selectedBranchId,
    onSelectBranchHandler,
}) => {
    useEffect(() => {
        if (selectedInfo?.branches && selectedInfo.branches !== selectedBranchId) {
            onSelectBranchHandler(selectedInfo.branches);
        }
    }, [ selectedInfo?.branches, selectedBranchId, onSelectBranchHandler ]);
};
